import { Skeleton, Typography } from 'antd'
import React, { Suspense } from 'react'

import { Rfqs } from './Rfqs'

export const RfqsPage = () => {
  return (
    <>
      <Typography.Title>RFQs</Typography.Title>

      <Suspense fallback={<Skeleton />}>
        <Rfqs />
      </Suspense>
    </>
  )
}
